import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraSpaPageContainer } from './JiraSpaPageContainer.tsx';
import { JiraSpaPageContainerOld } from './JiraSpaPageContainerOld.tsx';

export const PageContainer = functionWithCondition(
	() => fg('jpx-463-spa-relay-query'),
	JiraSpaPageContainer,
	JiraSpaPageContainerOld,
);
